<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.667 5.33398C27.3742 5.33398 28.0523 5.61514 28.5524 6.11523C29.0525 6.61533 29.3337 7.29341 29.3337 8.00065V12.6673C29.3337 13.0355 29.0302 13.3262 28.6735 13.4173C28.2137 13.5348 27.7895 13.7739 27.4482 14.1152C26.9481 14.6153 26.667 15.2934 26.667 16.0007C26.667 16.7079 26.9481 17.386 27.4482 17.8861C27.7895 18.2274 28.2137 18.4665 28.6735 18.584C29.0302 18.6751 29.3337 18.9658 29.3337 19.334V24.0007C29.3337 24.7079 29.0525 25.386 28.5524 25.8861C28.0523 26.3862 27.3742 26.6673 26.667 26.6673H5.33366C4.62641 26.6673 3.94834 26.3862 3.44824 25.8861C2.94815 25.386 2.66699 24.7079 2.66699 24.0007V19.334C2.66699 18.9658 2.97041 18.6751 3.32715 18.584C3.78698 18.4665 4.21112 18.2274 4.55241 17.8861C5.05251 17.386 5.33366 16.7079 5.33366 16.0007C5.33366 15.2934 5.05251 14.6153 4.55241 14.1152C4.21112 13.7739 3.78698 13.5348 3.32715 13.4173C2.97041 13.3262 2.66699 13.0355 2.66699 12.6673V8.00065C2.66699 7.29341 2.94815 6.61533 3.44824 6.11523C3.94834 5.61514 4.62641 5.33398 5.33366 5.33398H26.667ZM14.6123 18.1699L11.0003 14.5605L9.33366 16.2272L14.8883 21.7819L22.667 11.7819L20.7217 10.1152L14.6123 18.1699Z"
      fill="currentColor"
    />
  </svg>
</template>
